// extracted by mini-css-extract-plugin
export default {"container":"style_container__F1mVD","header":"style_header__mXre0","list":"style_list__vZX9z","new-chat":"style_new-chat__OTN0e","empty-block":"style_empty-block__dJ-VL"};